import { PII_GATED_ATTACHMENT_TYPES } from './types';
import type { ConversationAttachmentType } from './types';

/**
 * Whether this attachment type's bytes need `customers.feature.pii-view` on top of `conversations.view`
 * (design §11.3, adr-merchant-portal-021 D3). `UNKNOWN` is treated conservatively as personal data —
 * the content endpoint's permission lists name every other type but not it (contract gap G15).
 */
export function isPiiGatedAttachmentType(type: ConversationAttachmentType): boolean {
  return type === 'UNKNOWN' || (PII_GATED_ATTACHMENT_TYPES as readonly string[]).includes(type);
}
